// extracted by mini-css-extract-plugin
export var blockBtn = "hero-module--block-btn--79b52";
export var hero = "hero-module--hero--74353";
export var hero__button = "hero-module--hero__button--4ac85";
export var hero__element = "hero-module--hero__element--1bcfa";
export var hero__elementFive = "hero-module--hero__element--five--2a0a0";
export var hero__elementFour = "hero-module--hero__element--four--06d81";
export var hero__elementOne = "hero-module--hero__element--one--02208";
export var hero__elementThree = "hero-module--hero__element--three--58831";
export var hero__elementTwo = "hero-module--hero__element--two--270e5";
export var hero__list = "hero-module--hero__list--64e69";
export var hero__listAdvantages = "hero-module--hero__list--advantages--a1e08";
export var hero__listAudience = "hero-module--hero__list--audience--38bd6";
export var hero__presentation = "hero-module--hero__presentation--70f52";
export var hero__subtitle = "hero-module--hero__subtitle--2c9fe";
export var hero__text = "hero-module--hero__text--97cf3";
export var hero__title = "hero-module--hero__title--6b8b7";
export var hero__wrapper = "hero-module--hero__wrapper--edc7b";
export var mainBtn = "hero-module--main-btn--342d3";
export var mainTitle = "hero-module--main-title--2eda3";